'use strict';
/*!
* main.js
*/

window.app = {};
import App from './components/App';

app = new App();
app.__init();